import {
  BILLING_VENDOR_FETCH_REQUEST,
  BILLING_VENDOR_FETCH_REQUEST_SUCCESS,
  BILLING_VENDOR_FETCH_REQUEST_FAILURE,
  BILLING_VENDOR_CLEAN_REQUEST,
  BILLING_VENDOR_RESET_LOADING,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const billingVendorReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BILLING_VENDOR_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BILLING_VENDOR_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data,
        errors: {},
        pagination: {
          current: action.data?.currentPage,
          pageSize: action.data?.pageSize,
          total: action.data?.totalRecord,
          totalPage: action.data?.totalPage,
        },
      });

    case BILLING_VENDOR_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BILLING_VENDOR_RESET_LOADING:
      return Object.assign({}, state, {
        loading: false,
      });

    case BILLING_VENDOR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default billingVendorReducer;
